import { ScheduleReader } from "./ScheduleReader";
import store from "../../store/store";

// Tools
const ft = require("../Tools/FileTools");

/**
 * This object purpose is to read the schedule file, extract the schedule and gives what to read to the player.
 * It contains a lit of all the scheduleReader associated with the schedule.
 */
export class ScheduleManager {
  constructor(schedulesReader, pathToFile = null, preview = false, alert = false, userData = null) {
    this.schedulesReader = schedulesReader;
    this.preview = preview;
    this.count = -1;
    this.pathToFile = pathToFile;
    this.alert = alert;

    if (this.preview) {
      if (userData !== null) {
        this.pathToFile = "./temp/" + userData.socId + "/" + userData.userId + "/readingPreview/";
      }
    }
  }

  /**
   * Get the next scheduleReader that has to be read in the schedule
   * @returns { ScheduleReader } Next project or Null if no project read
   */
  getNext() {
    const nextIdx = this.getNumProjectScheduled();
    //const prevIdx = this.count;
    /*
    if(nextIdx != prevIdx) {
    */
    if (nextIdx >= 0 && nextIdx < this.schedulesReader.length) {
      const next = this.schedulesReader[nextIdx];
      this.count = nextIdx;

      return next;
    } else {
      return {};
    }
    /*
    }
    else {
      let retry = new Object();
      retry.controllerProject = "retry";
      return retry;
    }
      */
  }

  getPrevious() {
    this.decrementCount();

    if (this.count >= 0 && this.count < this.schedulesReader.length) {
      const previous = this.schedulesReader[this.count];
      return previous;
    } else {
      return null;
    }
  }

  searchProject(nameProject) {
    return new Promise((resolve, reject) => {
      this.schedulesReader.forEach((element) => {
        const currentName = element.scheduleName.replace(".zip", "");
        if (nameProject == currentName) {
          return resolve(element);
        }
      });

      return reject("search project found nothing named " + nameProject);
    });
  }

  getNumProjectScheduled() {
    let scheduleControl = true;

    if (this.schedulesReader !== undefined) {
      for (let i = this.count + 1; i < this.schedulesReader.length; i++) {
        const schedule = this.schedulesReader[i].schedule;
        if (!schedule.permanent) {
          scheduleControl = this.scheduleControlCurrent(schedule);
        }
        if (schedule.permanent || scheduleControl) {
          return i;
        }
      }

      for (let i = 0; i < this.count + 1; i++) {
        const schedule = this.schedulesReader[i].schedule;
        if (!schedule.permanent) {
          scheduleControl = this.scheduleControlCurrent(schedule);
        }
        if (schedule.permanent || scheduleControl) {
          return i;
        }
      }
    } else {
      console.warn("Schedule reader not defined");
      return -1;
    }
  }

  scheduleControlCurrent(schedule) {
    const moment = require("moment");
    const currentDate = moment().format("YYYY-MM-DD");
    const currentTime = moment().format("HH:mm");
    const currentDay = moment().isoWeekday() - 1;

    if (schedule.dateFrom !== undefined) {
      if (currentDate < schedule.dateFrom) {
        return false;
      }
    }

    if (schedule.dateTo !== undefined) {
      if (currentDate > schedule.dateTo) {
        return false;
      }
    }

    // If the two times are defined
    if (schedule.timeFrom !== undefined && schedule.timeTo !== undefined) {
      if (schedule.timeFrom <= schedule.timeTo) {
        // If timeFrom <= timeTo check if the project is between these two values
        if (currentTime < schedule.timeFrom || currentTime > schedule.timeTo) {
          return false;
        }
      } else {
        // If timeFrom > timeTo check if the project is beyond one of these two values
        if (currentTime > schedule.timeTo && currentTime < schedule.timeFrom) {
          return false;
        }
      }
    }
    // If timeFrom is defined and timeTo not we check if we are after timeFrom
    if (schedule.timeFrom !== undefined && schedule.timeTo === undefined) {
      if (currentTime < schedule.timeFrom) {
        return false;
      }
    }
    // If timeTo is defined and timeFrom not we check if we are before timeTo
    if (schedule.timeFrom === undefined && schedule.timeTo !== undefined) {
      if (currentTime > schedule.timeTo) {
        return false;
      }
    }

    if (schedule.days[currentDay] !== undefined) {
      if (schedule.days[currentDay].active == 0) {
        return false;
      }
    }

    // If it pass all test
    return true;
  }

  incrementCount() {
    if (this.count == this.schedulesReader.length - 1) {
      this.count = 0;
      return;
    }
    this.count++;
  }

  decrementCount() {
    if (this.count == 0) {
      this.count = this.schedulesReader.length - 1;
      return;
    }
    this.count--;
  }

  length() {
    return this.schedulesReader.length;
  }

  /**
   * This is the main process of this object. It load every ScheduleReader and make them ready to be use on the player.
   */
  load() {
    return new Promise((resolve, reject) => {
      if (this.schedulesReader !== undefined) {
        // We create a list of ScheduleReader
        this.schedulesReader = this.schedulesReader.map((reader) => {
          return new ScheduleReader(reader.schedule);
        });

        // We do specific functions on each project scheduled
        this.schedulesReader.forEach((project) => {
          let path = this.pathToFile;

          if (this.preview) {
            let filepath = project.schedule.projectData.path_dl;
            filepath = filepath.replace(store.state.config.url.server + "/mediacenter/", "./mediacenter/");

            path = path + "projects/" + ft.getFileNameFromPath(filepath);
          } else {
            path = path + "projects/" + ft.getFileNameFromPath(project.schedule.projectData.path);
          }

          // Load the project
          project.loadCompiledProjectPath(path);
          // Read the project
          project.readProjectController();
        });

        resolve();
      } else {
        reject("Error on schedule manager load");
      }
    });
  }
}
